import {ElementUtil} from '../../utils/elementUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';

export function showMigrationCompanyDetailsDialog(v6CompanyId, companyName, migrationService) {
	var dialog = ElementUtil.create({
		tag: 'dl-dialog',
		title: 'V6 Billing Details' + (companyName ? ' - ' + companyName : ''),
		icon: 'vaadin:invoice',
		width: .75,
		height: .75,
		listeners: {
			ready: function() {
				dialog.show();

				var contentLayout = ElementUtil.create({
					tag: 'dl-flex-layout',
					children: [
						{
							tag: 'div',
							itemid: 'statusSection',
							slot: 'primary',
							innerHTML: 'Loading billing account details...'
						},
						{
							tag: 'vaadin-grid',
							itemid: 'productGrid',
							slot: 'primary',
							theme: 'row-stripes column-borders compact',
							style: 'margin-top: 12px;',
							'all-rows-visible': true,
							defaults: {
								tag: 'vaadin-grid-column',
								autoWidth: true
							},
							children: [
								{path: 'productCode', header: 'Product'},
								{path: 'featureProductCode', header: 'Feature'},
								{path: 'billingType', header: 'Billing Type'},
								{path: 'itemPriceAmt', header: 'Price'},
								{path: 'currencyCode', header: 'Currency'},
								{path: 'key', header: 'Key'}
							]
						}
					]
				});

				dialog.addToContentElement(contentLayout);

				migrationService.getV6BillingAccount(v6CompanyId).then(function(response) {
					var billing = response && response.data ? response.data : response;
					var statusSection = ElementUtil.query(contentLayout, 'statusSection');
					var productGrid = ElementUtil.query(contentLayout, 'productGrid');

					if (!billing) {
						statusSection.innerHTML = 'Billing account details are not available for this company.';
						productGrid.items = [];
						return;
					}

					var account = billing.account || {};
					var currentStatus = billing.currentStatus || {};
					var company = billing.company || {};
					var detailTable = ElementUtil.create({
						tag: 'dl-detail-table',
						itemid: 'detailtable'
					});

					detailTable.updateDetails([
						{key: 'Account Summary', value: '-', section: true},
						{key: 'Company', value: StringUtil.blankIfNull(company.companyName) + ' (' + v6CompanyId + ')'},
						{key: 'Account Status', value: StringUtil.blankIfNull(currentStatus.accountStatus)},
						{key: 'Status Comment', value: StringUtil.blankIfNull(currentStatus.statusComment)},
						{key: 'Active Status', value: StringUtil.blankIfNull(currentStatus.activeStatus)},
						{key: 'Payment Terms', value: StringUtil.blankIfNull(account.ourPaymentTerms)},
						{key: 'Payment Type', value: StringUtil.blankIfNull(account.paymentType)},
						{key: 'Do Not Bill', value: account.doNotBillFlag === true ? 'Yes' : 'No'},
						{key: 'Billing Cycle Day', value: StringUtil.blankIfNull(account.billingCycleDay)},
						{key: 'Last Bill Cycled Date', value: StringUtil.blankIfNull(account.lastBillCycledDate)}
					]);

					statusSection.innerHTML = '';
					statusSection.appendChild(detailTable);

					var productsHeader = ElementUtil.create({
						tag: 'div',
						style: 'margin-top: 16px; font-weight: 600;',
						innerHTML: 'Current Order Items (' + (billing.currentOrderItems || []).length + ')'
					});
					statusSection.appendChild(productsHeader);

					var orderItems = (billing.currentOrderItems || []).map(function(orderItem) {
						var item = orderItem.item || {};
						var price = orderItem.price || {};
						return {
							productCode: item.productCode || '',
							featureProductCode: item.featureProductCode || '',
							billingType: item.billingType || '',
							itemPriceAmt: price.itemPriceAmt != null ? price.itemPriceAmt : '',
							currencyCode: price.currencyCode || '',
							key: orderItem.key || ''
						};
					});

					productGrid.items = orderItems;
				}).catch(function() {
					ElementUtil.query(contentLayout, 'statusSection').innerHTML =
						'Unable to load billing account details for this company.';
				});
			}
		}
	});
}
